import React, { Component } from 'react';
import '../styles/Home.css';
import banner from '../images/banner.png';
import squareLab from '../images/squareBlack.png';
import squareImage from '../images/squareImg.png';
import certificadoIcon from '../images/certif-icon.svg';
import medidaIcon from '../images/medida.svg';
import comunicacionIcon from '../images/comunicacion.svg';
import informeIcon from '../images/informes-icon.svg';
import anmat from '../images/anmat.png';
import modalBanner from '../images/modal.png'

import Banner from './Banner'
import CardSection from './CardSection'
import ScrollTop from './ScrollTop'
import Analytics from './Analytics'

import { Redirect } from 'react-router-dom';


class Home extends Component {
    constructor(props) {
        super(props);
        this.redirectPath = this.redirectPath.bind(this)
    }
    redirectPath(path) {
        this.props.history.push(path);
    }
    componentDidMount(){
        
    }
    //Call this function in componentDidMount() for show on load home
    loadInfoModal(){
        if(window.innerWidth > 780){
            let overlay = document.getElementById("overlay")
            overlay.style.backgroundColor = "rgba(0,0,0,0.7)"
            overlay.style.zIndex = "2"
            let loginModal = document.getElementById("infoModal")
            loginModal.style.display = "block";
        }
    } 
    closeModal(){
        let overlay = document.getElementById("overlay")
        overlay.style.backgroundColor = "unset"
        overlay.style.zIndex = "-2"
        let loginModal = document.getElementById("infoModal")
        loginModal.style.display = "none";
    }
    render(){
        return (
            <div className="Home">
                <ScrollTop />
                <Analytics />
                <div class="info-panel-home modal" id="infoModal">
                    <img src={modalBanner} />
                    <div class="close-button" onClick={this.closeModal}></div>
                    <h3>MEJORAMOS EL SERVICIO DE INFORMACIÓN ONLINE.</h3>
                    <h5>Sumamos nuevas tecnologías para realizar un mejor seguimiento de su empresa.</h5>
                    <p>Conozca el estado de su negocio en el momento y lugar que necesite accediendo a nuestro sistema on-line. Sistemas y equipamiento de última generación. Data Center duplicado para contingencias.</p>
                    <div class="btn-panel-container">
                        <button class="btn-details-panel">MÁS DETALLES</button>
                    </div>
                </div>
                <div class="home-container">
                    <Banner title="Operamos en todos los canales comerciales" className="banner-home"
                     description="Manejamos procesos completos a medida y le ayudamos a optimizar recursos humanos y administrativos." 
                     textButton="MODELO DE NEGOCIO" imageBanner={banner} />
                    <div class="square-images">
                        <div class="square-home black-square">
                            <div class="text-square-container">
                                <h4>LABORATORIOS</h4>
                                <p>
                                Servicios comerciales a medida.<br/>
                                Administración de cobranzas y cuentas corrientes.<br/>
                                Información de su operación en linea<br/>
                                </p>
                            </div>
                            <div class="button-container"><button class="details" onClick={() => this.redirectPath("/servicios")}>Servicios</button></div>
                            <img src={squareImage} alt="Nature" />
                        </div>
                        <div class="square-home white-square">
                            <div class="text-square-container">
                                <h4>CLIENTES</h4>
                                <p>Droguerías y Farmacias<br/>
                                Supermercados<br/>
                                Instituciones Públicas y Privadas<br/>
                                Servicios e Institutos de Radiología<br/>
                                </p>
                            </div>
                            <div class="button-container"><button class="details" onClick={() => this.redirectPath("/landing")}>Más detalles</button></div>
                            <img src={squareImage} alt="Nature"/>
                        </div>
                    </div>
                    <div class="ventajas-home">
                        <h1>VENTAJAS <span>COMPETITIVAS</span></h1>
                        <p>Nos diferenciamos por un trato justo e igualitario hacia todos nuestros clientes, brindando y asegurando un servicio óptimo, con los más altos estándares de calidad, integridad y transparencia, alineados con los principios de compliance que tienen las compañías que nos integran.</p>
                        <div class="ventaja-container">
                            <div class="ventaja-card">
                                <img src={comunicacionIcon} />
                                <h2>Comunicación</h2>
                                <p>Asistencia diaria de nuestros representantes comerciales y asesoramiento constante.</p>
                            </div>
                            <div class="ventaja-card">
                                <img src={medidaIcon} />
                                <h2>Servicios a medida</h2>
                                <p>Nos aseguramos que nuestros servicios estén diseñados a medida de cada laboratorio.</p>
                            </div>
                            <div class="ventaja-card">
                                <img src={certificadoIcon} />
                                <h2>Certificaciones</h2>
                                <p>Contamos con Certificaciones internacionales que avalan nuestras políticas de calidad.</p>
                            </div>
                            <div class="ventaja-card">
                                <img src={informeIcon} />
                                <h2>Informes detallados</h2>
                                <p>Devoluciones con análisis semanales. Información online disponible para realizar seguimiento.</p>
                            </div>
                        </div>
                    </div>
                    <div class="laboratorio-home">
                        <div class="lab-head">
                            <h3>LABORATORIOS</h3>
                            <p>Trabaje usted también junto a los líderes</p>
                        </div>
                        <CardSection classContainer="laboratorio-home"/>
                    </div>
                    <div class="certificacion-home">
                        <div class="certificacion-head">
                            <h3>CERTIFICACIONES</h3>
                        </div>
                        <div class="certificacion-grid">
                            <div class="certif-image"> 
                                <img src={anmat} />
                            </div>
                            <div class="certif-center">
                                <ul>
                                    <li>Medicamentos</li>
                                    <li>Alimentos</li>
                                    <li>Reactivos para diagnóstico</li>
                                    <li>Ensayos clínicos</li>
                                </ul>
                            </div>
                            <div class="certif-right">
                                <ul>
                                    <li>Certificación ISO 9001</li>
                                    <li>Certificación ISAE 3402</li>
                                    <li>Sistema Validado según Normas GAMP 5</li>
                                    <li>Sarbanes-Oxley (Procesos Operativos)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                
                
            </div>
        );
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js